import styled, { css, keyframes } from 'styled-components';

/*
 * Appear row animations
 *
 * Note: The animation must be the same for all rows - switching animation-name
 * by row position (nth-child) restarts the animation of all following rows
 * whenever a row is inserted or removed (eg. new websocket fill on top).
 * The end color (stripes) is therefore parametrized via CSS property set
 * on even rows below, instead of separate keyframes.
 */
const appearRowAnimationRed = keyframes`
  from {
    background: var(--red2);
  }
  to {
    background: var(--appearRowEndBackground, transparent);
  }
`;

const appearRowAnimationGreen = keyframes`
  from {
    background: var(--green1);
  }
  to {
    background: var(--appearRowEndBackground, transparent);
  }
`;

/**
 * This row have animation green/red when it's first time rendered
 */
type IAppearParams = {
  $appearAnimationIgnorePeriod?: boolean;
  $noHoverEffect?: boolean;
  $stripes?: boolean;
  fontSize?: string;
};

const AppearAnimatedRow = styled.tr<IAppearParams>`
  ${({ onClick }) => (onClick ? 'cursor: pointer;' : '')}
  ${({ fontSize }) => (fontSize ? `font-size: ${fontSize};` : '')}

  ${props =>
    props.$noHoverEffect
      ? ''
      : `
      &:hover td {
        background: var(--primary7);
      }
    // border-left: 1px solid transparent;
    // &:hover {
      // background: var(--black1);
      // filter: brightness(120%);
      // border-left: 1px solid var(--white);
    // }
    // & td:first-child {
      // border-left: 1px solid transparent;
    // }
    // &:hover td:first-child {
      // border-left-color: var(--white);
    //}
  `}

  /* Apply animation via className */
  &.color-red {
    animation-duration: ${props =>
      props.$appearAnimationIgnorePeriod === true ? '0s' : '1s'};
    animation-name: ${appearRowAnimationRed};
  }
  &.color-green {
    animation-duration: ${props =>
      props.$appearAnimationIgnorePeriod === true ? '0s' : '1s'};
    animation-name: ${appearRowAnimationGreen};
  }

  /* Striped even rows - animation ends with stripe background color */
  ${props =>
    props.$stripes
      ? css`
          &:nth-child(even) {
            --appearRowEndBackground: var(--black1b);
          }
        `
      : ''}
`;

export default AppearAnimatedRow;
